import ProcurementLaneType from './ProcurementLaneTypes';

/** Lane Search Actions start */
export const getProcurementLaneListInProgress = (payload) => {
  return { type: ProcurementLaneType.GET_PROCUREMENT_LANE_LIST, payload };
};

export const getProcurementLaneListInSuccess = (payload) => {
  return {
    type: ProcurementLaneType.GET_PROCUREMENT_LANE_LIST_SUCCESS,
    payload,
  };
};

export const getProcurementLaneListInFail = (payload) => {
  return {
    type: ProcurementLaneType.GET_PROCUREMENT_LANE_LIST_FAIL,
    payload,
  };
};

export const setProcurementLaneListRequest = (payload) => {
  return {
    type: ProcurementLaneType.SET_PROCUREMENT_LANE_LIST_REQUEST,
    payload,
  };
};

export const createProcurementLaneInSuccess = (payload) => {
  return {
    type: ProcurementLaneType.CREATE_UPDATE_PROCUREMENT_LANE_SUCCESS,
    payload,
  };
};

export const createProcurementLaneInFail = (payload) => {
  return {
    type: ProcurementLaneType.CREATE_UPDATE_PROCUREMENT_LANE_FAIL,
    payload,
  };
};

export const resetProcurementLaneList = (payload) => {
  return {
    type: ProcurementLaneType.RESET_PROCUREMENT_LANE_LIST,
    payload,
  };
};

export const setAddNewLane = (payload) => {
  return { type: ProcurementLaneType.SET_ADD_NEW_LANE, payload };
};

export const updateSelectedLane = (payload) => {
  return { type: ProcurementLaneType.UPDATE_SELECTED_LANE, payload };
};
/** Lane Search Actions end */

export const selectedLaneList = (payload) => {
  return { type: ProcurementLaneType.SELECTED_LANE_LIST, payload };
};
